// extracted by mini-css-extract-plugin
export var baseButton = "_qm-0";
export var controlsArrowKeys = "_qm-1";
export var controlsResetButton = "_qm-2";
export var lightGameButton = "_qm-4 _qm-0";
export var playAgainButton = "_qm-5 _qm-0";
export var startGameButton = "_qm-3 _qm-0";